import { AvatarProps, Box, Typography } from "@mui/material";

import { useAppSelector } from "@/common/hooks/redux";
import {
  ChatParticipantDto,
  ChatParticipantOnlineStatus,
  ChatParticipantStatus,
} from "@/core/api/generated/v1";
import { selectChatParticipantOnlineStatus } from "@/store/communication/selectors";

import AppAvatar, { AppAvatarProps } from "../../Avatar/AppAvatar";
import { ChatParticipantStatusDisplay } from "./ChatParticipantStatusDisplay";

export interface ChatParticipantAvatarProps {
  chatId?: string | null;
  participant?: ChatParticipantDto | null;
  size?: AppAvatarProps["size"];
  withOnlineStatus?: boolean;
  withPopover?: boolean;
  sx?: AvatarProps["sx"];
}

export default function ChatParticipantAvatar({
  chatId,
  participant,
  size,
  withOnlineStatus = true,
  withPopover = true,
  sx,
}: ChatParticipantAvatarProps) {
  const participantId = participant?.id;
  const onlineStatus = useAppSelector((x) =>
    selectChatParticipantOnlineStatus(x, chatId || participant?.chatId, participantId),
  );
  const isOnline = onlineStatus === ChatParticipantOnlineStatus.Online;
  const isActive = !!participant && participant.status === ChatParticipantStatus.Active;
  const isInactive = !!participant && participant.status !== ChatParticipantStatus.Active;

  return (
    <AppAvatar
      participant={participant}
      size={size || 48}
      isOnline={isActive && isOnline}
      withOnlineStatus={withOnlineStatus}
      withPopover={withPopover}
      withFadedOpacity={isInactive}
      popoverContent={
        <Box>
          <Typography component='div' variant='subtitle1'>
            {participant?.personName?.name}{" "}
            <ChatParticipantStatusDisplay participant={participant} />
          </Typography>
          <Typography component='div' variant='body2' color='text.secondary'>
            {participant?.email}
          </Typography>
        </Box>
      }
      sx={sx}
    />
  );
}
